import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Modal.css';

export interface ModalProps {
    onClose: () => void;
    children: React.ReactNode;
    /** Дополнительный класс на панель диалога */
    className?: string;
    /** Закрывать по клику на оверлей (default: true) */
    closeOnBackdrop?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
    onClose,
    children,
    className = '',
    closeOnBackdrop = true,
}) => {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onClose]);

    const handleBackdrop = (e: React.MouseEvent<HTMLDivElement>) => {
        if (closeOnBackdrop && e.target === e.currentTarget) onClose();
    };

    return createPortal(
        <div className="cu-modal-overlay" onClick={handleBackdrop} aria-modal role="dialog">
            <div className={`cu-modal-panel ${className}`.trim()}>
                {children}
            </div>
        </div>,
        document.body
    );
};
